<template>
  <div>
    <div class="text-center ">
      <div class="excludeArea">
        <img src="../../assets/image/user-journey/should_exclude.svg" alt="">
        <div class="description mt-5">
          با توجه به وضعیتی که شرح دادید و همچنین محدودیت پلتفرم های آنلاین،در حال حاضر بهترین انتخاب برای شما دریافت
          کمک
          حضوری است.
        </div>
        <div class="description mt-3">
          در صورتی که در این زمینه نیاز به راهنمایی دارید، میتوانید به لینک زیر مراجعه کنید.
        </div>
        <v-alert
            class="emergencyInfo mt-8"
            type="info"
            outlined
            border="start"
            elevation="0"
        >
          <div class="emergencyInfo__title">
            تلفن های اورژانسی حوزه سلامت روان
          </div>
          <div class="emergencyInfo__item mt-2">
            اورژانس اجتماعی 123
          </div>
        </v-alert>
        <v-btn
            @click="resetJourney"
            text
            color="primary"
            style="background: #f0faf6"
            class="submitBtnOutline mt-4"
            elevation="0"
        >
          شروع دوباره
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  beforeDestroy() {
    // this.$emitEvent('changeVisibiltySeekback', true)
  },
  methods: {
    resetJourney() {
      localStorage.removeItem('set_session_token')
      localStorage.removeItem('match_additional_data')
      setTimeout(() => {
        location.reload();
      }, 500)
    }
  },
  mounted() {
    this.$emitEvent('changeVisibiltySeekback', false)
  },

}
</script>

<style lang="scss" scoped>
@media (min-width: 200px) and (max-width: 800px) {
  .excludeArea {
    width: 100% !important;
    padding: 20px;
    margin: 80px auto !important;
  }
  .excludeArea img{
    width: 30%;
  }
}

.excludeArea {
  width: 40%;
  margin: 130px auto 0px auto;
}

.description {
  color: #212121;
  text-align: right;
  font-size: var(--Font-Size-2xl, 20px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.submitBtnOutline {
  border-radius: 8px;
  width: 100%;
  height: 48px !important;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 45px;
}

.emergencyInfo {
  width: 100%;
  text-align: right;
  border-radius: 8px;
}

.emergencyInfo__title {
  color: #212121;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.emergencyInfo__item {
  color: #212121;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>